/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React from "react";

import ToolbarButton from "../ToolbarButton";

import DeleteIcon from "@material-ui/icons/Delete";
import PaidIcon from "@material-ui/icons/Check";
import NotPaidIcon from "@material-ui/icons/Close";
import RotateIcon from "@material-ui/icons/RotateRight";

import Link from "@material-ui/core/Link";

import { useStoreon } from "storeon/react";

const OrderButtons = props => {
  const { activeObject } = props;
  const {
    orderId,
    itemId,
    size,
    user,
    paymentMethod,
    paid
  } = activeObject.order;

  const { canvas } = useStoreon("canvas");
  return (
    <React.Fragment>
      <div>
        <div
          css={css`
            margin-right: 20px;
            display: block;
            align-items: center;
            justify-content: center;
            height: 48px;
            display: flex;
            flex-flow: row;
            font-size: 15px;
            > div {
              margin-right: 10px;
              display: flex;
              align-items: center;
            }
          `}
        >
          {orderId && (
            <div>
              <Link
                href={`/wp-admin/post.php?post=${orderId}&action=edit`}
                target="_blank"
              >
                <b>
                  #{orderId} | {itemId}
                </b>
              </Link>
            </div>
          )}
          <div>
            <b>Size:</b> {size.width * 0.1}x{size.height * 0.1}cm
          </div>

          {user && (
            <div>
              <b>
                {user.firstName} {user.lastName}
              </b>
            </div>
          )}
          {paymentMethod && (
            <div>
              {paymentMethod}
              {paid ? (
                <PaidIcon style={{ color: "green" }} />
              ) : (
                <NotPaidIcon style={{ color: "red" }} />
              )}
            </div>
          )}
        </div>
      </div>
      <div>
        <ToolbarButton
          desc="Rotate"
          tooltip
          icon={<RotateIcon />}
          onClick={() => {
            const grp = canvas.getActiveObject();
            const initialCoords = {
              left: grp.left,
              top: grp.top
            };
            const childImg = grp.getObjects()[0];
            if (childImg.angle) {
              childImg.rotate(0);
              grp.order.rotated = false;
            } else {
              childImg.rotate(90);
              grp.order.rotated = true;
            }
            grp._calcBounds();
            grp.left = initialCoords.left;
            grp.top = initialCoords.top;
            grp.setCoords();
            grp.canvas.renderAll();
            canvas.requestRenderAll();
          }}
        />
        <ToolbarButton
          desc="Remove"
          tooltip
          icon={<DeleteIcon />}
          onClick={() => {
            canvas.remove(canvas.getActiveObject());
          }}
        />
      </div>
    </React.Fragment>
  );
};

export default OrderButtons;
